import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectCurrentGroups, setCurrentGroups } from '../../Auth/authSlice';
import { List, Box, Typography, Avatar, Stack, IconButton, Tooltip, Paper } from '@mui/material';
import { variants } from '../../../variants/variants';
import { useLocation, useNavigate } from 'react-router-dom';
import Linkway from '../../../assets/Linkway/LinkwayLogo.png';
import ComingSoon from '../../WebView/components/CommingSoon';
import { Verified } from '@mui/icons-material';
import Overlay from './Overlay';
import ProfileSkeleton from './ProfileSkeleton';

// Dummy group data
const dummyGroups = [
  { id: 1, name: 'Team Linkway', description: 'Description for Team Linkway' },
  { id: 2, name: 'Group Alpha', description: 'Description for Group Alpha' },
  { id: 3, name: 'Group Beta', description: 'Description for Group Beta' },
  { id: 4, name: 'Group Gamma', description: 'Description for Group Gamma' },
];

const TeamLinkway = ({ content, handleProfileClick, style = {} }) => {
  const { pathname } = useLocation();
  const active = pathname.split('/')[2] === 'home';
  const navigate = useNavigate();

  const handleLinkwayClick = () => {
    navigate('/home/feedback');
  };

  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      style={style}
      onClick={handleLinkwayClick}
      sx={{
        p: 1,
        m: 1,
        mb: 0,
        pl: 0,
        borderBottom: 1,
        borderColor: 'divider',
        cursor: 'default',
        color: 'inherit',
        background: 'linear-gradient(180deg, #fff 10%,#EEF5FF 100% )',
        borderRadius: variants.boxRadius.SIDEBAR,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        animation: active ? 'pulse 1.5s infinite' : 'none',
        // filter: 'grayscale(100%)',
        '@keyframes pulse': {
          '0%': {
            boxShadow: '0 0 0 0 rgba(0, 123, 178, 0.7)',
          },
          '70%': {
            boxShadow: '0 0 0 10px rgba(0, 123, 178, 0)',
          },
          '100%': {
            boxShadow: '0 0 0 0 rgba(0, 123, 178, 0)',
          },
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', zIndex: 1 }}>
        <Tooltip title={'Group chats coming soon...'}>
          <IconButton sx={{ p: 0, m: 0 }} size='medium'>
            <img
              src={Linkway}
              style={{
                objectFit: 'contain',
                width: 40,
                height: 40,
                padding: '0.2rem',
                marginLeft: '0.3rem',
                borderRadius: '50%',
                border: '2px solid #03a9f4',
              }}
            />
          </IconButton>
        </Tooltip>
        <Box sx={{ ml: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography sx={{ fontSize: variants.BODY, fontWeight: 'bold', color: '#007bb2' }}>Linkway</Typography>
            <Verified sx={{ color: '#03a9f4', ml: 1, fontSize: '18px' }} />
          </Box>
          <Typography sx={{ fontSize: variants.TINY, color: '#004d40' }}>A way to linking...</Typography>
        </Box>
      </Box>
      <Box>
        <Typography sx={{ fontSize: variants.TINY, color: '#004d40' }}>Coming soon...</Typography>
      </Box>
    </Stack>
  );
};

const GroupList = () => {
  const dispatch = useDispatch();
  const groups = useSelector(selectCurrentGroups);
  const navigate = useNavigate();

  useEffect(() => {
    // Dispatching dummy data to the Redux store
    dispatch(setCurrentGroups({ group: dummyGroups }));
  }, [dispatch]);

  const handleProfileClick = () => {
    navigate(`/developer`);
  };

  return (
    <div className='content' style={{ padding: 0,height:"100%" }}>
      <List
        sx={{
          p: 0,
          pl: 0.65,
          overflowY: 'auto',
          height: '100%',
          border: 1,
          borderRadius: variants.boxRadius.SIDEBAR,
          borderColor: 'divider',
        }}
      >
        <TeamLinkway handleProfileClick={handleProfileClick} />
        <Box
          component={Paper}
          sx={{
            // backgroundColor: variants.boxBackground.PROFILE_CARD,
            p: 1,
            borderRadius: variants.boxRadius.SIDEBAR,
            // border: 1,
            m: 1,
            borderColor: 'divider',
            height: '100%',
            boxShadow: 'none',
            position: 'relative',
          }}
        >
          <ProfileSkeleton />
          <ProfileSkeleton />

          <Overlay />
        </Box>
      </List>
    </div>
  );
};

export default GroupList;
